import widgetText from '@model/layoutConfigs/widgetText'
import widgetProduct from '@model/layoutConfigs/widgetProduct'
import widgetForm from '@model/layoutConfigs/widgetForm'
import widgetImage from '@model/layoutConfigs/widgetImage'
import widgetImageGallery from '@model/layoutConfigs/widgetImageGallery'
import widgetAlbum from '@model/layoutConfigs/widgetAlbum'
import widgetContact from '@model/layoutConfigs/widgetContact'
import widgetContent from '@model/layoutConfigs/widgetContent'
import widgetInteractive from '@model/layoutConfigs/widgetInteractive'
import widgetProductBrand from '@model/layoutConfigs/widgetProductBrand'
import widgetCoupon from '@model/layoutConfigs/widgetCoupon'
import widgetMenuProduct from '@model/layoutConfigs/widgetMenuProduct'
import widgetFAQ from '@model/layoutConfigs/widgetFAQ'
import widgetEventCalendar from '@model/layoutConfigs/widgetEventCalendar'
import widgetProductCategory from '@model/layoutConfigs/widgetProductCategory'
import widgetQuotationForm from '@model/layoutConfigs/widgetQuotationForm'

export default {
  ...widgetText,
  ...widgetProduct,
  ...widgetForm,
  ...widgetImage,
  ...widgetImageGallery,
  ...widgetAlbum,
  ...widgetContact,
  ...widgetContent,
  ...widgetInteractive,
  ...widgetProductBrand,
  ...widgetCoupon,
  ...widgetMenuProduct,
  ...widgetFAQ,
  ...widgetEventCalendar,
  ...widgetProductCategory,
  ...widgetQuotationForm,
};